import {
  Box,
  Table,
  Tag,
  Text,
  
} from '@chakra-ui/react';
import { formatNumber } from "../../../../store/helpers";
import LineGraph from "../../../daily/LineGraph";

const formatDecimal = (value) => Number(value || 0).toFixed(2);

const ArrivalRatesPerServiceTable = ({
  data,
  index,
  branchName,
  reportIndex,
  branchIndex,
}) => {
  const { serviceName, average, min, max, total, chart } = data;

  const title = `${reportIndex || ""}.${branchIndex + 1}.${
    index + 1
  }. ${serviceName}`;
  return (
    <>
      <Box className="reportContainer" mt="20px">
        <h3>{title}</h3>
        <Tag.Root>
          <Tag.Label className="branchTag">{branchName} Branch</Tag.Label>
        </Tag.Root>
        {!total && <Text fontSize="sm">No data available for this report</Text>}

        {total ? (
          <>
            <Table.Root className="stripedTable" size="sm">
              <Table.Header>
                <Table.Row>
                  <Table.ColumnHeader>#</Table.ColumnHeader>
                  <Table.ColumnHeader borderRight="1px solid #dadce0"> Total Visitors</Table.ColumnHeader>
                  <Table.ColumnHeader borderRight="1px solid #dadce0">Average</Table.ColumnHeader>
                  <Table.ColumnHeader>Min</Table.ColumnHeader>
                  <Table.ColumnHeader>Max</Table.ColumnHeader>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                <Table.Row>
                  <Table.Cell>{index + 1}</Table.Cell>
                  <Table.Cell borderRight="1px solid #dadce0">{formatNumber(total)}</Table.Cell>
                  <Table.Cell borderRight="1px solid #dadce0">{formatDecimal(average)}</Table.Cell>
                  <Table.Cell>{formatNumber(min)}</Table.Cell>
                  <Table.Cell>{formatNumber(max)}</Table.Cell>
                </Table.Row>
              </Table.Body>
            </Table.Root>
            <Box className="arrivalRatesPerServiceChartBlock">
              <LineGraph
                chart={chart}
                height={"300px"}
                title={`${serviceName} Arrival Rates, Hour by Hour Comparison`}
              />
            </Box>
          </>
        ) : (
          <></>
        )}
      </Box>
    </>
  );
};

export default ArrivalRatesPerServiceTable;
